import { useSelector, useDispatch } from 'react-redux';
import { setUsername, clearUsername, selectUsername, setPatientId, clearPatientId,
  selectPatientId, setTokenData, clearTokenData, selectPatientInfo, selectProviderInfo,
  selectHealthcareSystemInfo, selectCaseInfo, selectInsuranceInfo, selectAppointmentInfo,
  setCurrentUser, clearCurrentUser, selectCurrentUser
} from '../slices/userSlice';

/**
 * Custom hook for managing user data in Redux store
 * @returns {Object} - User state and actions
 */
export const useUserData = () => {
  const dispatch = useDispatch();
  const username = useSelector(selectUsername);
  const patientId = useSelector(selectPatientId);
  const currentUser = useSelector(selectCurrentUser);
  const patientInfo = useSelector(selectPatientInfo);
  const providerInfo = useSelector(selectProviderInfo);
  const healthcareSystemInfo = useSelector(selectHealthcareSystemInfo);
  const caseInfo = useSelector(selectCaseInfo);
  const insuranceInfo = useSelector(selectInsuranceInfo);
  const appointmentInfo = useSelector(selectAppointmentInfo);

  const updateUsername = (newUsername) => { dispatch(setUsername(newUsername)); };
  const resetUsername = () => { dispatch(clearUsername()); };
  const updatePatientId = (newPatientId) => { dispatch(setPatientId(newPatientId)); };
  const resetPatientId = () => { dispatch(clearPatientId()); };
  const updateTokenData = (tokenData) => { dispatch(setTokenData(tokenData)); };
  const resetTokenData = () => { dispatch(clearTokenData()); };
  const updateCurrentUser = (userData) => { dispatch(setCurrentUser(userData)); };
  const resetCurrentUser = () => { dispatch(clearCurrentUser()); };

  return { username, patientId, currentUser, patientInfo, providerInfo, healthcareSystemInfo, caseInfo, insuranceInfo, appointmentInfo, updateUsername, resetUsername, updatePatientId, resetPatientId, updateTokenData, resetTokenData, updateCurrentUser, resetCurrentUser };
};

export default useUserData;
